var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "field",
        {
          staticStyle: { "font-weight": "bold" },
          attrs: {
            label: _vm.label,
            disabled: _vm.disabled,
            "error-text": _vm.errorText,
          },
        },
        [
          _c("dropdown-field", {
            attrs: {
              source: _vm.source,
              "text-field": "account",
              "auto-assign": _vm.autoAssign,
              searchable: "",
              placeholder: _vm.placeholder,
            },
            model: {
              value: _vm.val,
              callback: function ($$v) {
                _vm.val = $$v
              },
              expression: "val",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-2 flex gap-2" },
        [
          _c(
            "label",
            {
              staticClass: "text-brand-black flex-grow",
              staticStyle: { "font-weight": "bold", "font-size": "12px" },
            },
            [_vm._v("Show All Trading Accounts?")]
          ),
          _vm._v(" "),
          _c("switchbox", {
            attrs: { "on-text": "Yes", "off-text": "No", width: "50px" },
            model: {
              value: _vm.showAllTrdAccounts,
              callback: function ($$v) {
                _vm.showAllTrdAccounts = $$v
              },
              expression: "showAllTrdAccounts",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }